import { render } from "./Stop.vue?vue&type=template&id=0dc54cf0"
import script from "./Stop.vue?vue&type=script&lang=js"
export * from "./Stop.vue?vue&type=script&lang=js"
script.render = render

export default script